const stringee = {
  getStringeeClientInstance: () => {
    return new StringeeClient();
  },
};

export default stringee;
